export default __webpack_public_path__ + "static/media/biofit-builder-series-MTHD.48f77303.png";